import {Badge} from "@mantine/core";
import {BillingChannel, ReconciliationReport} from "../types.ts";
import {hasDiscrepancies, totalDiscrepancies} from "../utils/discrepancyHealth.ts";

// The billing channel a run targeted. FNP-616: channel is a lowercase catalog token.
// The color map is cosmetic-only (unknown channels fall back to gray) — it never gates
// behaviour, so a new provider needs no change here.
const CHANNEL_COLORS: Record<string, string> = {
    stripe: 'indigo',
    aws_marketplace: 'orange',
    flexi_network: 'gray',
};

export const ChannelBadge = ({channel}: { channel: BillingChannel | string }) => {
    const color = CHANNEL_COLORS[channel] ?? 'gray';
    return <Badge color={color}>{channel}</Badge>;
};

// Health badge for a reconciliation run. Green when our billing matched the channel
// exactly (no discrepancies); red with the count when something didn't reconcile —
// the "look here when a customer disputes a charge" signal.
export const DiscrepancyBadge = ({record}: { record: ReconciliationReport }) => {
    if (hasDiscrepancies(record)) {
        return <Badge color={'red'}>{totalDiscrepancies(record)} discrepanc{totalDiscrepancies(record) === 1 ? 'y' : 'ies'}</Badge>;
    }
    return <Badge color={'green'}>Reconciled</Badge>;
};
